"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.withClientContext = exports.useClientContext = exports.makeInitialContext = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _client = require("@sanity/client");
var _imageUrl = require("@sanity/image-url");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var initialContext = {
  urlFor: null,
  client: null
};
var makeInitialContext = exports.makeInitialContext = function makeInitialContext(config) {
  var client = (0, _client.createClient)(config);
  var urlFor = (0, _react.useCallback)(function (source) {
    return (0, _imageUrl.createImageUrlBuilder)(client).image(source);
  }, [client]);
  return (0, _extends2.default)({}, initialContext, {
    urlFor: urlFor,
    client: client
  });
};
var ClientContext = exports.default = /*#__PURE__*/(0, _react.createContext)(initialContext);
var withClientContext = exports.withClientContext = function withClientContext(Component) {
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(ClientContext.Consumer, null, function (context) {
      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, props, {
        clientContext: context
      }));
    });
  };
};
var useClientContext = exports.useClientContext = function useClientContext() {
  var context = (0, _react.useContext)(ClientContext);
  if (context === undefined) {
    throw new Error("useClientContext must be used within a <ClientContext.Provider>");
  }
  return context;
};